import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import 'moment/locale/bg';
import 'moment/locale/cs';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/et';
import 'moment/locale/fr';
import 'moment/locale/el';
import 'moment/locale/hr';
import 'moment/locale/hu';
import 'moment/locale/it';
import 'moment/locale/lt';
import 'moment/locale/lv';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/ro';
import 'moment/locale/sk';
import 'moment/locale/sl';
import 'moment/locale/tr';

export interface Language {
    label: string;
    code: string;
    name: string;
}

export const LANGUAGES: Language[] = [
    { label: 'BG', code: 'bg', name: 'Български' },
    { label: 'CS', code: 'cs', name: 'Čeština' },
    { label: 'DE', code: 'de', name: 'Deutsch' },
    { label: 'EN', code: 'en', name: 'English' },
    { label: 'ES', code: 'es', name: 'Español' },
    { label: 'ET', code: 'et', name: 'Eesti' },
    { label: 'FR', code: 'fr', name: 'Français' },
    { label: 'EL', code: 'el', name: 'Ελληνικά' },
    { label: 'HR', code: 'hr', name: 'Hrvatski' },
    { label: 'HU', code: 'hu', name: 'Magyar' },
    { label: 'IT', code: 'it', name: 'Italiano' },
    { label: 'LT', code: 'lt', name: 'Lietuvių' },
    { label: 'LV', code: 'lv', name: 'Latviešu' },
    { label: 'PL', code: 'pl', name: 'Polski' },
    { label: 'PT', code: 'pt', name: 'Português' },
    { label: 'RO', code: 'ro', name: 'Română' },
    { label: 'SK', code: 'sk', name: 'Slovenčina' },
    { label: 'SL', code: 'sl', name: 'Slovenščina' },
    { label: 'TR', code: 'tr', name: 'Türkçe' },
    { label: 'UK', code: 'uk', name: 'Yкраїнська' },
    { label: 'SR', code: 'sr', name: 'Cрпски језик' }
];

const resources: { [lang: string]: { translation: any } } = {};

LANGUAGES.forEach(lang => {
    resources[lang.code] = { translation: require(`./locales/${lang.code}.json`) };
});

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init(
        {
            resources,
            lng: LANGUAGES.map(l => l.code).includes(navigator.language) ? navigator.language : 'en',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false
            }
        },
        () => {
            moment.locale(i18n.language);
        }
    );

i18n.on('languageChanged', async (lang: string) => {
    moment.locale(lang);
});

export default i18n;
